import { render, staticRenderFns } from "./HelpManual.vue?vue&type=template&id=1365d066"
import script from "./HelpManual.vue?vue&type=script&lang=js"
export * from "./HelpManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports